module.exports = "<svg id=\"2f81c7d1-5a05-4659-b116-69eff63dfe7a\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>location</title><path d=\"M25.72,1A16,16,0,0,0,9.44,17.21a19,19,0,0,0,1.34,6.06c4.55,9.88,8.11,15.49,15,25.39,7-10.36,10.81-15.6,15.36-25.39a18.62,18.62,0,0,0,1-6.06A16,16,0,0,0,25.72,1Zm-.11,26.25a9.91,9.91,0,1,1,9.82-9.91A9.86,9.86,0,0,1,25.61,27.26Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Location.svg
// module id = 497
// module chunks = 1